module.exports = __webpack_public_path__ + "static/media/equalicare-img27.a4355140.png";